"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CRYPTO_TOKENS_TICKES = void 0;
const bsc_token_1 = require("./bsc-token");
const eth_token_1 = require("./eth-token");
const tron_token_1 = require("./tron-token");
exports.CRYPTO_TOKENS_TICKES = [
    ...new Set([...bsc_token_1.BSC_TOKEN_TICKERS, ...eth_token_1.ETH_TOKEN_TICKERS, ...tron_token_1.TRON_TOKEN_TICKERS])
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3J5cHRvLXRva2VuLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RpY2tlcnMvY3J5cHRvLXRva2VuLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLDJDQUErQztBQUMvQywyQ0FBK0M7QUFDL0MsNkNBQWlEO0FBRXBDLFFBQUEsb0JBQW9CLEdBQUc7SUFDbEMsR0FBRyxJQUFJLEdBQUcsQ0FBQyxDQUFDLEdBQUcsNkJBQWlCLEVBQUUsR0FBRyw2QkFBaUIsRUFBRSxHQUFHLCtCQUFrQixDQUFDLENBQUM7Q0FDaEYsQ0FBQSJ9